exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:767px){.fl-survey-main-layout{margin-top:60px;height:100%}.fl-survey-main-layout .fl-survey-back-continue-btn{padding:15px 0;display:flex;align-items:flex-start;flex-direction:column-reverse}.fl-survey-main-layout .fl-survey-back-continue-btn .survey-align-btn{width:100%;padding:15px 26px}}@media(min-width:768px){.fl-survey-back-continue-btn{display:flex;justify-content:flex-start}.fl-survey-back-continue-btn .survey-align-btn:nth-child(2){margin-left:20px}}", ""]);

// exports
